var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVibrazioneSider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5853 1.68945C20.5029 3.62306 22.7991 7.23754 22.7991 10.9998C22.7991 14.7622 20.5029 18.3766 17.5853 20.3101M6.41301 1.68945C3.49545 3.62306 1.19922 7.23754 1.19922 10.9998C1.19922 14.7622 3.49545 18.3766 6.41301 20.3101M16.0959 6.15841C17.2462 7.30471 18.3304 9.24766 18.3304 10.9998C18.3304 12.7521 17.2462 14.6949 16.0959 15.8412M7.90256 6.15841C6.75231 7.30471 5.66808 9.24766 5.66808 10.9998C5.66808 12.7521 6.75231 14.6949 7.90256 15.8412M12.7442 10.9998C12.7442 11.4111 12.4107 11.7446 11.9994 11.7446C11.5881 11.7446 11.2545 11.4111 11.2545 10.9998C11.2545 10.5885 11.5881 10.255 11.9994 10.255C12.4107 10.255 12.7442 10.5885 12.7442 10.9998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibrazioneSider);
export default __webpack_public_path__ + "static/media/VibrazioneSider.97dc65966e20ec93a3b67aca93335ceb.svg";
export { ForwardRef as ReactComponent };